import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  center?: boolean;
  children: ReactNode;
  expand?: boolean;
}

const CardBody = ({ center = false, children, expand = false }: Props) => {
  const className = classnames({
    flex: true,
    'flex-col': true,
    'min-h-px': true,
    '!p-4': true,
    'justify-center': center,
    'flex-1': expand,
  });

  return <div className={className}>{children}</div>;
};

export default CardBody;
